import {Component, ElementRef, Input, OnInit, ViewChild} from '@angular/core';
import Chart, {ChartPoint, ChartType} from 'chart.js';
import {ChartDataSets, ChartOptions} from 'chart.js';
import {ExcTranslation} from 'exc-core';
import {forEach} from '@angular/router/src/utils/collection';

@Component({
  selector: 'app-exc-chart',
  templateUrl: './app-exc-chart.component.html',
  styles: [`
    .chart-container {
      position: relative;
      width: 100%;
      height: calc(100% - 16px);
    }
  `]
})
export class AppExcChartComponent extends ExcTranslation implements OnInit {

  @Input() width: string;
  @Input() height: string;
  private _colors = [
    {f: 'rgba(32, 83, 148, 1)', b: 'rgba(32, 83, 148, 0.4)'},
    {f: 'rgba(250, 169, 51, 1)', b: 'rgba(250, 169, 51, 0.4)'},
    {f: 'rgba(3, 181, 56, 1)', b: 'rgba(3, 181, 56, 0.4)'},
    {f: 'rgba(88, 200, 224, 1)', b: 'rgba(88, 200, 224, 0.4)'},
    {f: 'rgba(181, 3, 154, 1)', b: 'rgba(181, 3, 154, 0.4)'}
  ];

  @ViewChild('chartElement') chartElement: ElementRef<HTMLCanvasElement>;
  private colorIndex  = 0;
  private chartIndex = 0;
  private isMenuExpanded = false;
  private _chart: Chart;
  set chart(value: Chart) {
    this._chart = value;
  }

  get chart(): Chart {
    return this._chart;
  }
  private _charts: any[] = null;
  @Input() set charts(value) {
    this._charts = value;
    this.chartIndex = 0;
    this.generateChart();
  }
  get charts() {
    return this._charts;
  }

  getTitle() {
    if (this._charts === null) {
      return this.getRessource('Loading');
    }
    if (this._charts && this._charts.length > 0) {
      return this.getRessource(this._charts[this.chartIndex].Title);
    }
    return this.getGlobal('NoData');
  }

  generateChart() {
    if (!this._charts  || this._charts.length === 0) {
      return;
    }
    if (this.chart) {
      this.chart.destroy();
    }
    const context = this.chartElement.nativeElement.getContext('2d');
    const c = this._charts[this.chartIndex];
    let colorIndex = 0;
    if (c.datasets.length === 1 && (c.datasets[0].type === 'pie' || c.datasets[0].type === 'doughnut')) {
        if (c.datasets[0].labelTranslated !== true) {
          c.datasets[0].label = this.getRessource(c.datasets[0].label);
          c.datasets[0].labelTranslated = true;
        }
        c.datasets[0].borderWidth = 1;
        c.datasets[0].backgroundColor = [];
        c.datasets[0].borderColor = [];
        colorIndex = 0;
        for (const a of this._colors) {
          c.datasets[0].backgroundColor.push(a.b);
          c.datasets[0].borderColor.push(a.f);
        }
        for (let l = 0; l < c.labels.length; l++) {
          const nl = this.getRessource(c.labels[l]);
          if (nl !== null && nl !== '' && nl.indexOf('AppExcChartComponent') === -1 ) {
            c.labels[l] = nl;
          }
        }
    } else {
      for (const d of c.datasets) {
        if (d.labelTranslated !== true) {
          d.label = this.getRessource(d.label);
          d.labelTranslated = true;
        }
        d.borderWidth = 1;
        d.backgroundColor = this._colors[colorIndex].b;
        d.borderColor = this._colors[colorIndex].f;
        colorIndex = colorIndex + 1;
        if (colorIndex === this._colors.length - 1) {
          colorIndex = 0;
        }
      }
    }
    const opt = c.Option === null || c.Option === undefined ? {} : JSON.parse(c.Option);
    opt['responsive'] = true;
    opt['maintainAspectRatio'] = false;
    const x = {
      data: {
        datasets: c.datasets,
        labels: c.labels
      },
      type: c.datasets[0].type,
      options: opt
    };
    this.chart = new Chart(context, x);
  }

  constructor() {
    super();
  }

  ngOnInit() {
  }
}
